import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, Subject } from 'rxjs';
import { tap } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { UserService } from './user.service';
import { WbUserDTO } from '../models/wb-user-dto';

@Injectable({
  providedIn: 'root'
})
export class AuthJwtService {

  private pathAPI = environment.urlAPI;
  private authenticationChanged = new Subject<boolean>();
  private tokenName = 'tokenWhatsappBusiness';
  private refreshTokenName = 'refreshTokenWhatsappBusiness';

  constructor(private http: HttpClient,
    private userService: UserService) {
  }

  public login(body: any): Observable<any> {
    let urlToken = this.pathAPI + 'Login';
    return this.http.post<any>(urlToken, body).pipe(
      tap(async (res: any) => {
        if (res.tokenWhatsappBusiness.length > 0) {
          this.setStorageToken(res.tokenWhatsappBusiness);
          this.setStorageRefreshToken(res.refreshTokenWhatsappBusiness);
          this.userService.initializeUserData();
        }
      })
    );
  }

  public loginPassword(body: any): Observable<any> {
    let urlToken = this.pathAPI + 'Login/Login';
    return this.http.post<any>(urlToken, body).pipe(
      tap(async (res: any) => {
        if (res.tokenWhatsappBusiness && res.tokenWhatsappBusiness.length > 0) {
          this.setStorageToken(res.tokenWhatsappBusiness);
          this.setStorageRefreshToken(res.refreshTokenWhatsappBusiness);
          this.userService.initializeUserData();
        }
      })
    );
  }

  public sendCode(body: any): Observable<any> {
    let urlToken = this.pathAPI + 'Login/SendCodeOTP';
    return this.http.post<any>(urlToken, body).pipe(
      tap(async (res: any) => { })
    );
  }

  public refreshToken(body: any): Observable<any> {
    let urlToken = this.pathAPI + 'Login/Refresh';
    return this.http.post<any>(urlToken, body).pipe(
      tap(async (res: any) => {
        if (res.tokenWhatsappBusiness.length > 0) {
          this.setStorageToken(res.tokenWhatsappBusiness);
          this.setStorageRefreshToken(res.refreshTokenWhatsappBusiness);
        }
      })
    );
  }

  public isAdminUser(): boolean {
    const token = this.getToken();
    if (!token || token.length === 0) {
      return false;
    }
    try {
      const userData = this.getUserDataManual(token);
      return userData && userData.Admin === true;
    } catch (error) {
      return false;
    }
  }

  public logout(): void {
    this.setStorageToken(undefined);
    this.setStorageRefreshToken(undefined);
    this.userService.setUserData(null);
  }

  private setStorageToken(value: any): void {
    window.localStorage[this.tokenName] = value;
    this.authenticationChanged.next(this.isAuthenticated());
  }

  private setStorageRefreshToken(value: any): void {
    window.localStorage[this.refreshTokenName] = value;
  }

  public isAuthenticated(): boolean {
    return !(window.localStorage[this.tokenName] === undefined ||
      window.localStorage[this.tokenName] === null ||
      window.localStorage[this.tokenName] === 'null' ||
      window.localStorage[this.tokenName] === 'undefined' ||
      window.localStorage[this.tokenName] === '');
  }

  public isAuthenticationChanged(): any {
    return this.authenticationChanged.asObservable();
  }

  public getToken(): any {
    if (window.localStorage[this.tokenName] === undefined ||
      window.localStorage[this.tokenName] === null ||
      window.localStorage[this.tokenName] === 'null' ||
      window.localStorage[this.tokenName] === 'undefined' ||
      window.localStorage[this.tokenName] === '') {
      return '';
    }
    return window.localStorage[this.tokenName];
  }

  public getRefreshToken(): any {
    if (window.localStorage[this.refreshTokenName] === undefined ||
      window.localStorage[this.refreshTokenName] === null ||
      window.localStorage[this.refreshTokenName] === 'null' ||
      window.localStorage[this.refreshTokenName] === 'undefined' ||
      window.localStorage[this.refreshTokenName] === '') {
      return '';
    }
    return window.localStorage[this.refreshTokenName];
  }

  public getUserDataManual(token): WbUserDTO {
    if (token == null || token.trim() == '') return null;
    let jwt = JSON.stringify(token);
    return this.getTokenModel(jwt);
  }

  private getTokenModel(jwt): WbUserDTO {
    if (jwt == null || jwt.trim() == '' || jwt.trim() == '') return null;
    let jwtData = jwt.split('.')[1];
    let decodedJwtJsonData = this.b64DecodeUnicode(window.atob(jwtData));
    let decodedJwtData = JSON.parse(decodedJwtJsonData);
    let userData = JSON.parse(decodedJwtData.UserData);
    return userData;
  }

  private b64DecodeUnicode(str) {
    return decodeURIComponent(str.split('').map(function (c) {
      return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));
  }
}
